import { FC } from "react";

interface ClosingCrossPopupSVGProps {
    className?: string;
    fill?: string;
}

const ClosingCrossPopupSVG: FC<ClosingCrossPopupSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="35"
            height="35"
            viewBox="0 0 35 35"
            fill={props.fill || "none"}
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="35" height="35" rx="17.5" fill="white" fillOpacity="0.7" />
            <path
                d="M11 11L17.5 17.5M24 24L17.5 17.5M17.5 17.5L24 11L11 24"
                stroke="#848484"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ClosingCrossPopupSVG;
